import { Grid, Box } from "@mui/material";
import VideoPreview from "./VideoPreview";

export default function TrailerGrid({ trailerLinks = [] }) {
  if (!Array.isArray(trailerLinks) || trailerLinks.length === 0) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={2}>
        {trailerLinks.map((link, index) => (
          <Grid
            size={{ xs: 12, sm: 6 , md: 4 }}
            key={index}
          >
            <VideoPreview watchLink={link} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}